import { ICellRendererParams } from "@ag-grid-community/core";
import { Text } from "@chakra-ui/react";
import { TcmEncounter } from "@metriport/shared-internal/dist/api/tcm-encounter";
import { formatDateTimeInLocalNoYear } from "../../../shared/date";

export const LatestStatusCell = (p: ICellRendererParams<TcmEncounter>) => {
  const encounter = p.data as TcmEncounter;

  if (!encounter) return null;

  const { outreachStatus, lastOutreachDate, outreachLogs } = encounter;

  // Get the latest status from outreach logs or fall back to outreachStatus
  let latestStatus = outreachStatus;
  let latestDate = lastOutreachDate;

  if (outreachLogs && outreachLogs.length > 0) {
    // Get the latest log (last in stack)
    const latestLog = outreachLogs[outreachLogs.length - 1];
    latestStatus = latestLog?.status ?? "Not Started";
    latestDate = new Date(latestLog?.timestamp ?? "");
  } else if (outreachStatus) {
    latestStatus = outreachStatus;
    latestDate = new Date(lastOutreachDate ?? "");
  }

  const formattedDate = latestDate ? formatDateTimeInLocalNoYear(latestDate) : "";

  const statusText =
    latestStatus === "Not Started" || !latestDate
      ? latestStatus
      : `${latestStatus}: ${formattedDate}`;

  return (
    <Text fontSize="sm" noOfLines={1}>
      {statusText}
    </Text>
  );
};
